import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {AppService} from '../../../app/app.service';

@Injectable({
  providedIn: 'root'
})
export class SettingMapService extends AppService {
    className: string = 'SettingMapService';
    url: string = '/settings/front_map_settings';
    /** Путь до контроллера загрузки файлов в систему */
    fileUploadUrl: string = this.serverUrl + '/files/front_files/file_upload';

    /**
     * Получение настроек
     */
    public getSettings(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl +  this.url + '/get_settings', data, this._httpOptions);
    }


    public setSettings(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl +  '/settings/front_map_settings/save_settings', data, this._httpOptions);
    }
}
